import axios from 'axios';
import Store from '@/store/index';
import { apiUrl } from '@/utility/axios';
import { alert } from '@/utility/messages';

//  保護者ログイン
const userKey = 'user:parent_hoikm';
const permanentKey = `${userKey} permanent` as const;
let lastUpdated = 0;

export interface LoginUser {
  pmail: string;
  password: string;
  save: boolean;
}

export interface AuthInfo {
  pcode: number;
  pname: string;
  pmail: string;
  subUser: boolean;
  childs: ChildName[];
  token: string;
}

interface ChildName {
  ccode: number;
  cname: string;
  btel: string;
}

export function initUser(): LoginUser {
  return <LoginUser>{
    pmail: '',
    password: '',
    save: isPermanent(),
  };
}

export function getLoginParentUser() {
  const json = getStorage().getItem(userKey);
  if (json === null) return null;
  const loginUser = JSON.parse(json) as AuthInfo;
  return loginUser;
}

function isPermanent() {
  return localStorage.getItem(permanentKey) === 'true';
}

function getStorage() {
  return isPermanent() ? localStorage : sessionStorage;
}

export async function updateLoginParentUser() {
  await new Promise(resolve => setTimeout(resolve));
  if (Date.now() - lastUpdated < 60 * 1000) return;
  lastUpdated = Date.now();
  const user = getLoginParentUser();
  if (!user) {
    return;
  }
  lastUpdated = Date.now();
  const config = {
    headers: { Authorization: 'Bearer ' + user.token },
  };
  const response = await axios.get<AuthInfo>(`${apiUrl}/auth/parent`, config);
  setLoginUser(response.data, isPermanent());
}

export async function login(pmail: string, password: string, save: boolean) {
  if (!pmail) {
    alert('メールアドレス・パスワードが間違っているか、入力されていない可能性があります。ご確認下さい。');
    return;
  }
  const response = await axios.post<AuthInfo>(`${apiUrl}/auth/parent`, { pmail: pmail, password: password, sender: 'parent' });
  setLoginUser(response.data, save);
}

function setLoginUser(loginUser: AuthInfo, permanent: boolean) {
  lastUpdated = Date.now();
  localStorage.setItem(permanentKey, JSON.stringify(permanent));
  getStorage().setItem(userKey, JSON.stringify(loginUser));
}

export function logout() {
  getStorage().removeItem(userKey);
}

export function getChildName(auth: AuthInfo | null, ccode: number): string {
  if (!auth?.childs?.length) return '-';
  const find = auth.childs.find(v => v.ccode === ccode);
  if (!find) return '-';
  return find.cname;
}

export function getBaseTel(auth: AuthInfo | null, ccode: number): string {
  if (!auth?.childs?.length) return '-';
  const find = auth.childs.find(v => v.ccode === ccode);
  if (!find) return '-';
  return find.btel;
}
